import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatOption, MatSelect } from '@angular/material';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../../../core/services/responsive.service';
import {
  Document,
  DocumentKeyPair, PaginateKeyPair, SortKeyPair
} from "../../../document/search-document-sign/search-document-sign.component";
import { MatSort } from "@angular/material/sort";
import { Paginate } from "../../../document/document-group-manage/document-group-manage.component";
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-synchronize-customer',
  templateUrl: './synchronize-customer.component.html',
  styleUrls: ['./synchronize-customer.component.scss']
})
export class SynchronizeCustomerComponent  implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('allSelectedGroup', { static: false }) allSelectedGroup: MatOption;
  @ViewChild('groupSelect', { static: false }) groupSelect: MatSelect;
  customer = {
    enterpriseId: localStorage.getItem('enterpriseId'),
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    foreignName: '',
    abbreviation: '',
    taxCode: '',
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    types: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: '',
    issuedAt: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeCertificate: '',
    representativeIssuedDate: '',
    representativeIssuedOn: '',
    birthday: '',
    sex: null,
    businessType: null,
    enterpriseTypeId: 'null',
    status: null,
    isDeleted: null,
    files: '',
    cityId: null,
    wardId: null,
    districtId: null,
    address: '',
    taxCodeOrCertificateNo: null,
    taxCodeOrCertificate: null,
    customerType: null,
    emailOrPhoneOrName: null,
    customerGroupNames: []
  };
  group = {
    id: [],
    createdTime: '',
    description: '',
    name: '',
  }
  isFormChanging: boolean = false
  checkAll: boolean;
  enterpriseType: comboBox[] = [];
  dataSelected: Map<any, Document> = new Map<any, Document>();
  parentDocuments: Document[];
  childOldDataList: DocumentKeyPair = {};
  childPaginateList: PaginateKeyPair = {};
  childSortList: SortKeyPair = {};
  childIsExpanding: Array<string>;
  groupData: comboBox[] = [];
  GroupCustomersId = []
  GroupCustomersFilterCtrl: FormControl = new FormControl();
  public filteredGroupCustomers: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  enterpriseTypeFilterCtrl: FormControl = new FormControl();

  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  checkFocus = true;
  enterpriseList: any;
  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "check", showMobile: true },
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "certificateNo", showMobile: true },
    { def: "email", showMobile: false },
    { def: "phone", showMobile: false },
    { def: "customerType", showMobile: false },
  ];

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  oldData = this.customer;
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  subscription: Subscription;
  personalId = EnterpriseTypes.PERSONAL;
  permissions: any;
  userId: any;

  // Variable for saving userType from session storage of current user
  userType: number;
  enterpriseTypeI18n = new Map();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('enterpriseTypeSelect', { static: false }) enterpriseTypeSelect: MatSelect;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  public enterpriseId: string;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private customerService: CustomerService,
    public commonService: CommonService,
    private breadcrumbsService: BreadcrumbsService,
    private route: ActivatedRoute,
    private router: Router,
    private message: Message,
    private toastr: ToastrService,
    private storageService: StorageService,
    public customerFilter: CustomerFilterLanguage,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.userId = localStorage.getItem('userId');
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.setUserType();
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.setValueI18nToMap();
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl, this.filteredEnterpriseType); });
    this.GroupCustomersFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.groupData, this.GroupCustomersFilterCtrl, this.filteredGroupCustomers);
        });
    this.getEnterpriseType();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
      { label: 'breadcrumbs.management_customer', url: 'customers', params: [], highlight: false },
      { label: 'breadcrumbs.customer_synchronize', url: 'customer_synchronize', params: [], highlight: false },
    ]);
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  setValueI18nToMap() {
    this.enterpriseTypeI18n.set(10000, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_personal');
    this.enterpriseTypeI18n.set(10001, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_private_company');
    this.enterpriseTypeI18n.set(10002, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_authority');
    this.enterpriseTypeI18n.set(10003, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_government_agencies');
    this.enterpriseTypeI18n.set(10004, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_state_enterprise');
    this.enterpriseTypeI18n.set(10005, 'enterprise_customer_management.cbx_custommer_type.cbx_individual_business_households');
  }

  /**
   * Get user type from session storage and set to userType variable
   */
  setUserType() {
    this.userType = this.storageService.getUserTypeFromSessionStorage();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  /**
   * Load all customer, lazy loading
   * @param page: number
   * @param pageSize: number
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let tempTenantId: any;
    let keyword: '';
    let paramEnterpriseTypeId: [];
    let paramStatus: [];
    let paramTaxCodeOrCertificateNo: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        tempTenantId = params.tenantId;
        // Defaults to 0 if no query param provided.
        if (typeof tempTenantId !== 'undefined') {
          page = params.page || 0;
          pageSize = params.pageSize || 10;
          keyword = params.keyword || '';
          paramEnterpriseTypeId = params.enterpriseTypeId ? params.enterpriseTypeId.split(',').map(function (item: string) {
            return parseInt(item, 10);
          }) : 10;
          paramStatus = params.status ? params.status.split(',').map(function (item: string) {
            return parseInt(item, 10);
          }) : [];
          paramTaxCodeOrCertificateNo = params.taxCodeOrCertificateNo || '';
        }
      });


    if (typeof tempTenantId !== 'undefined') {
      this.customer.emailOrPhoneOrName = keyword;
      this.customer.taxCodeOrCertificateNo = paramTaxCodeOrCertificateNo;
      this.customer.taxCodeOrCertificate = paramTaxCodeOrCertificateNo;
      this.customer.status = paramStatus.length > 1 ? 'null' : paramStatus.toString();
      this.customer.enterpriseTypeId = paramEnterpriseTypeId.length > 1 ? 'null' : paramEnterpriseTypeId.toString();
    }

    if ((this.userType !== -1 && this.userType !== 2) || (this.permissions.includes(4))) {
      this.customerService.filterCustomers({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        enterpriseId: localStorage.getItem('enterpriseId'),
        keyword: typeof tempTenantId !== 'undefined' ? keyword : '',
        enterpriseTypeId: typeof tempTenantId !== 'undefined' ? paramEnterpriseTypeId : this.enterpriseList,
        status: typeof tempTenantId !== 'undefined' ? paramStatus : [0, 1],
        taxCodeOrCertificateNo: typeof tempTenantId !== 'undefined' ? paramTaxCodeOrCertificateNo : null,
        // "enterpriseId": 1
      }).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
    } else if (this.userType === 2 && !this.permissions.includes(4)) {
      this.customerService.filterCustomersForGuest({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        taxCodeOrCertificate: this.oldData.taxCodeOrCertificate,
      }).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
    }
  }

  /**
   * Filter customer
   */

  onFilterCustomers(page: number = 0, pageSize: number = 10) {
    const status: [] | any = this.oldData.status == null || this.oldData.status === 'null' ? [0, 1] : [Number(this.oldData.status)];
    const enterpriseTypeId: [] | any = this.oldData.enterpriseTypeId == null ||
      this.oldData.enterpriseTypeId === 'null' ? this.enterpriseList : [this.oldData.enterpriseTypeId];
    if ((this.userType !== -1 && this.userType !== 2) || (this.permissions.includes(4))) {
      this.customerService.filterCustomers({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        enterpriseId: localStorage.getItem('enterpriseId'),
        taxCodeOrCertificateNo: this.oldData.taxCodeOrCertificateNo,
        keyword: this.oldData.emailOrPhoneOrName,
        status,
        enterpriseTypeId,
        idCustomerGroupList: this.group.id
      }).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
    } else if (this.userType === 2 && !this.permissions.includes(4)) {
      this.customerService.filterCustomersForGuest({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        taxCodeOrCertificate: this.oldData.taxCodeOrCertificate,
      }).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
    }
  }

  public onSelectionChange(element) {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  checkCheckAll() {
    let data = this.dataSource.data.filter(item => item.hasPermission);
    for (let i = 0; i < data.length; i++) {
      const currentRow = data[i];
      if (!this.dataSelected.has(currentRow.id)) {
        this.checkAll = false;
        break;
      }
      if (i === data.length - 1) {
        this.checkAll = true;
      }
    }
  }

  public checkAllDocument() {
    this.dataSource.data.forEach(data => {
      if (data.hasPermission) {
        data.checked = this.checkAll;
        this.dataSelected.set(data.id, data);
        if (!this.checkAll) {
          this.dataSelected.delete(data.id);
        }
      }
    });
  }


  /**
   * Bind data from api
   */
  private bindData(rs: any) {
    if (rs == null || rs.data == null || rs.data.dataRow == null) {
      return 0;
    }
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
    rs.data.dataRow.forEach(async(row) => {
      if(row.syncStatus === 'SYNCED')
      row.syncStatusMessage = await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_synced');
      else if (row.syncStatus === 'NOT_SYNCED')
      row.syncStatusMessage =  await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_not_synced');
    });
    this.dataSource.data = rs.data.dataRow;
    /* đối chiếu list mới trả về và danh sách object đã check */
    // nếu mà map object đã check tồn tại ở trong list hiện => chuyển trạng thái thành checked = true
    this.initParent(rs);
    this.checkCheckAll();
  }

  /**
   * Bind old search data to variable oldData to avoid error
   */
  onClickBtnFilter() {
    this.oldData = { ...this.customer };
  }

  /**
   * Get wards list from local storage or api
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
        this.enterpriseList = this.enterpriseType.map(x => {
          return x.id;
        });
        this.loadData();
      }
    });
  }
  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;

    this.parentDocuments.forEach(parent => {
      parent.taxCode = (parent.customerTaxCode == null || parent.customerTaxCode === '') ?
        parent.customerCertificateNo : parent.customerTaxCode;
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.initDataSelected();
    this.dataSource.data = this.parentDocuments;
    this.childIsExpanding = []; // close all parent
  }

  initDataSelected() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (this.dataSelected.has(this.parentDocuments[i].id)) {
        this.parentDocuments[i].checked = true;
      }
    }

    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (!this.dataSelected.has(this.parentDocuments[i].id)) {
        this.checkAll = false;
        break;
      }
      if (i === this.parentDocuments.length - 1) {
        this.checkAll = true;
      }
    }
  }

  /**
  * Back to list customers
  */
   onNoClick(): void {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.router.navigate(['/home-enterprise/customers'], {});
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/customers'], {});
    }
  }
}
